import { Button } from '@/components/base/button'
import { Dialog, DialogActions, DialogBody, DialogTitle, ShowProps } from '@/components/base/dialog'
import { useEffect, useState } from 'react'
import { CategoryQuery } from './__generated__/show_query'
import { Query } from './show_query'
import { useQuery } from '@apollo/client'
import { Inline as Loading } from '@/components/loading'
import { Inline as Error } from '@/components/error'
import { Badge as CategoryBadge } from '@/components/category/badge'
import { Accordion } from '@/components/accordion'
import { DeleteDialog } from '@/components/delete_dialog'
import { Mutation as DeleteMutation } from './delete_mutation'
import { Query as TableQuery } from './table_query'
import { EditDialog } from './edit_dialog'
import { Text } from '@/components/base/text'
import { Carousel } from '../carousel'
import { formatCurrency } from '@/helpers/formatCurrency'

type Category = CategoryQuery['categories']['nodes'][0]

export const ShowDialog = ({ id, open, setOpen }: ShowProps) => {
  const [openEdit, setOpenEdit] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)
  const [category, setCategory] = useState<Category | null>(null)
  const { data, loading, error } = useQuery<CategoryQuery>(Query, { variables: { filters: { idEq: id } } })

  useEffect(() => {
    if (!data || !id) return

    setCategory(data.categories.nodes[0])
  }, [id, data])

  const onEdit = () => {
    setOpenEdit(true)
  }
  const onDelete = () => {
    setOpenDelete(true)
  }

  const onDeleteSuccess = () => {
    setOpenDelete(false)
    setOpen(false)
  }

  return (
    <>
      <Dialog open={open} size="7xl" onClose={setOpen}>
        <DialogTitle>
          {
            loading || !category
              ? <Loading />
              : <div className="flex flex-row justify-between">
                <div className="flex flex-row gap-4 items-center pb-6 relative">
                  { category.name }
                  {
                    category.parent &&
                      <CategoryBadge category={{ name: category.parent.fullname, color: category.parent.color }} />
                  }
                </div>
              </div>
          }
        </DialogTitle>
        <DialogBody>
          { error && <Error message={error.message} />}
          { category && <div className="flex flex-col gap-4">
            <Carousel images={category.images} />
            <Accordion title="Asset types">
              {/* <AssetTypesTable filters={{ categoryIdEq: category.id}} pageSize={5} /> */}
              <Text>Boo</Text>
            </Accordion>
            <Accordion title="Packages">
              {/* <PackagesTable filters={{ categoryIdEq: category.id}} pageSize={5} /> */}
              <Text>Boo</Text>
            </Accordion>
            <Accordion title="Stats">
              <div>
                <p>Total count: {category.totalAssetTypeCount}</p>
                <p>Total cost: {formatCurrency('gbp',category.totalAssetTypeCost)} </p>
                <p>Revenue: {formatCurrency('gbp',category.totalRevenue)}</p>
                <p>Return on investment: {formatCurrency('gbp',category.totalReturnOnInvestment)}</p>
              </div>
            </Accordion>
          </div> }
        </DialogBody>
        <DialogActions>
          { category && <Button color="amber" onClick={onEdit}>Edit</Button> }
          { category && <Button color="red" onClick={onDelete}>Delete</Button> }
        </DialogActions>
      </Dialog>
      { category && <EditDialog id={category.id} open={openEdit} setOpen={setOpenEdit} /> }
      {
        category &&
          <DeleteDialog
            id={category.id}
            mutation={DeleteMutation}
            open={openDelete}
            refetchQueries={[TableQuery]}
            setOpen={setOpenDelete}
            onSuccess={onDeleteSuccess}
          />
      }
    </>
  )
}
